var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-version"},[_vm._v(" Версия "+_vm._s(_vm.version)+" "),(_vm.buildTime)?[_vm._v(" · сборка "+_vm._s(_vm.buildTime))]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }